import { render, staticRenderFns } from "./EditionTree.vue?vue&type=template&id=ac5f3266&scoped=true&"
import script from "./EditionTree.vue?vue&type=script&lang=js&"
export * from "./EditionTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5f3266",
  null
  
)

export default component.exports